module.exports = __webpack_public_path__ + "media/educator_advisory_board/Jeff_Stahlman-6e0a7296.png";